import { useEffect, useState, useRef, RefObject } from 'react'
import throttle from 'lodash/throttle'
import ResizeObserver from 'resize-observer-polyfill'

const useResizeObserver = (
  resizeSubject: RefObject<Element>,
  wait?: number
) => {
  const [contentRect, setContentRect] = useState({})
  const resizeObserver = useRef<any>(null)

  useEffect(() => {
    observeThrottled(ResizeObserver)
    interface DOMRectReadOnly {
      readonly bottom: number
      readonly height: number
      readonly left: number
      readonly right: number
      readonly top: number
      readonly width: number
    }
    function observeThrottled(RO: {
      new (callback: ResizeObserverCallback): ResizeObserver
      prototype: ResizeObserver
    }) {
      const throttledObserve = throttle((entries: ResizeObserverEntry[]) => {
        const { width, height, top, right, bottom, left } = entries[0]
          .contentRect as DOMRectReadOnly
        setContentRect({ width, height, top, right, bottom, left })
      }, wait || 0) // throttle for 1000ms

      resizeObserver.current = new RO((entries: ResizeObserverEntry[]) => {
        throttledObserve(entries)
      })

      if (resizeSubject.current) {
        // @ts-ignore
        resizeObserver.current.observe(resizeSubject.current)
      }
    }

    return disconnect
  }, [resizeSubject, wait])

  function disconnect() {
    if (resizeObserver.current) {
      // @ts-ignore
      resizeObserver.current.disconnect()
    }
  }

  return contentRect as DOMRectReadOnly
}
export default useResizeObserver
